<audio #playerEl controls="controls" class="preview-object" [class.hidden]="invalidMedia"></audio>

<default-preview *ngIf="invalidMedia"></default-preview>